// MFA step 3 — the Founder's recovery email link lands here. The token is read once and stripped from the address bar
// before any network call (useCapturedParams), then sent only in a POST body. Nothing happens until the Founder confirms.
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { useCapturedParams } from "../../lib/cleanUrl";
import { mfaErr } from "../../lib/webauthn";

export default function MfaRecover() {
  const { token } = useCapturedParams();
  const [state, setState] = useState(token ? "ready" : "missing");
  const [err, setErr] = useState("");
  const confirm = async () => {
    setState("busy"); setErr("");
    try { await api.post("/mfa/founder-recovery/confirm", { token }); setState("done"); }
    catch (e) { setErr(mfaErr(e)); setState("failed"); }
  };
  return (
    <main className="min-h-screen bg-[#F5F1E8] px-6 py-16 text-[#12233F]" data-testid="mfa-recover-page" data-state={state}>
      <div className="mx-auto max-w-xl border-t-4 border-[#C6A15B] pt-6 space-y-4">
        <p className="font-mono text-[11px] uppercase tracking-[2px] text-[#8A6D35]">ERF ConstructionOS · Sign-in security</p>
        <h1 className="font-display text-3xl font-semibold">Reset your two-step sign-in</h1>
        {state === "missing" && <p role="alert" data-testid="mfa-recover-missing">Open the link from the recovery email. It works once and expires after 15 minutes.</p>}
        {(state === "ready" || state === "busy") && (
          <>
            <p data-testid="mfa-recover-explain">This removes your passkeys, authenticator app, recovery codes and remembered devices. Afterwards, sign in with your password and set up a passkey again.</p>
            <button type="button" onClick={confirm} disabled={state === "busy"} data-testid="mfa-recover-confirm"
              className="min-h-[44px] px-5 rounded bg-[#12233F] text-white font-semibold focus:outline-none focus:ring-2 focus:ring-[#C6A15B] disabled:opacity-60">
              {state === "busy" ? "Resetting…" : "Reset my two-step sign-in"}
            </button>
          </>
        )}
        {state === "done" && <p role="status" data-testid="mfa-recover-done">Two-step sign-in was reset. Sign in with your password, then go to Sign-in security to add a passkey.</p>}
        {state === "failed" && <p role="alert" className="text-red-800" data-testid="mfa-recover-error">{err}</p>}
        {(state === "done" || state === "failed") && (
          <Link to="/login" className="inline-flex items-center min-h-[44px] px-5 rounded border border-[#12233F] font-semibold focus:outline-none focus:ring-2 focus:ring-[#C6A15B]"
            data-testid="mfa-recover-login">Go to sign in</Link>
        )}
      </div>
    </main>
  );
}
